import { Vue, prop } from 'vue-class-component';
import { Transition } from 'vue';
import styles from './styles.module.scss';

class LoaderProps {
	show = prop<boolean>({ default: false });
}

export class Loader extends Vue.with(LoaderProps) {
	render() {
		return (
			<Transition name="loader_fade">
				<div v-show={ this.show } class={ styles.loaderContainer }>
					<div class={ styles.loader }></div>
				</div>
			</Transition>
		);
	}
}
